import { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Heart, ShoppingBag, Menu, X, Sun, Moon } from "lucide-react";
import { useShop } from "@/context/ShopContext";

const LINKS = [
  { to: "/", label: "Accueil" },
  { to: "/boutique", label: "Boutique" },
  { to: "/trouver-mon-parfum", label: "Trouver mon parfum" },
  { to: "/comparer", label: "Comparateur" },
  { to: "/fidelite", label: "Fidélité" },
  { to: "/suivi", label: "Suivi" },
];

const Navbar = () => {
  const { cartCount, favorites } = useShop();
  const [open, setOpen] = useState(false);
  const [dark, setDark] = useState(() => localStorage.getItem("anm_theme") === "dark");

  useEffect(() => {
    document.documentElement.classList.toggle("dark", dark);
    localStorage.setItem("anm_theme", dark ? "dark" : "light");
  }, [dark]);

  return (
    <header data-testid="nav-header" className="sticky top-0 z-40 border-b border-[#EADFCB] bg-white/80 backdrop-blur-md">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-3 sm:px-8">
        <Link to="/" className="flex items-center gap-2.5" data-testid="nav-logo">
          <span className="flex h-10 w-10 items-center justify-center rounded-full border border-[#C59B27]/60 bg-gradient-to-br from-white to-[#F7EEDB] font-accent text-xs font-semibold text-[#1A1714]">
            ANM
          </span>
          <span className="font-accent text-lg tracking-[0.25em] text-[#1A1714]">PARIS</span>
        </Link>

        <nav className="hidden items-center gap-7 lg:flex">
          {LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              className={({ isActive }) =>
                `text-sm font-medium transition-colors hover:text-[#C59B27] ${
                  isActive ? "text-[#C59B27]" : "text-[#5C5449]"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-1.5">
          <button
            data-testid="theme-toggle"
            onClick={() => setDark(!dark)}
            aria-label={dark ? "Mode jour" : "Mode nuit"}
            className="flex h-10 w-10 items-center justify-center rounded-full text-[#5C5449] transition-all hover:bg-[#F7EEDB] hover:text-[#C59B27] active:scale-90"
          >
            {dark ? <Sun size={19} /> : <Moon size={19} />}
          </button>
          <Link
            to="/favoris"
            data-testid="nav-favorites-link"
            className="relative flex h-10 w-10 items-center justify-center rounded-full text-[#5C5449] transition-colors hover:bg-[#F7EEDB] hover:text-[#C59B27]"
            aria-label="Favoris"
          >
            <Heart size={19} />
            {favorites.length > 0 && (
              <span className="absolute -right-0.5 -top-0.5 flex h-5 w-5 items-center justify-center rounded-full bg-[#F2A7A0] text-[10px] font-bold text-white">
                {favorites.length}
              </span>
            )}
          </Link>
          <Link
            to="/panier"
            data-testid="nav-cart-link"
            className="relative flex h-10 w-10 items-center justify-center rounded-full text-[#5C5449] transition-colors hover:bg-[#F7EEDB] hover:text-[#C59B27]"
            aria-label="Panier"
          >
            <ShoppingBag size={19} />
            {cartCount > 0 && (
              <span data-testid="cart-count-badge" className="absolute -right-0.5 -top-0.5 flex h-5 w-5 items-center justify-center rounded-full bg-[#C59B27] text-[10px] font-bold text-white">
                {cartCount}
              </span>
            )}
          </Link>
          <button
            data-testid="mobile-menu-button"
            onClick={() => setOpen(!open)}
            className="flex h-10 w-10 items-center justify-center rounded-full text-[#1A1714] lg:hidden"
            aria-label="Menu"
          >
            {open ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>
      </div>

      {open && (
        <nav className="border-t border-[#EADFCB] bg-white px-4 py-4 lg:hidden">
          {LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              onClick={() => setOpen(false)}
              className={({ isActive }) =>
                `block rounded-lg px-3 py-2.5 text-sm font-medium ${
                  isActive ? "bg-[#F7EEDB] text-[#C59B27]" : "text-[#5C5449]"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>
      )}
    </header>
  );
};

export default Navbar;
